import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class ArbeitsbereichOption {
  constructor({
    markierung,
    name,
    id,
  }: {
    markierung: Markierung;
    name: string;
    id: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.id = id;
  }

  id: string;
  markierung: Markierung;
  name: string;

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
